'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import whichRecommendedProvider from '~/assets/logos/which-recommended-provider-rail-holidays.png';
import styles from './WhichBadge.module.css';
export const WhichBadge = () => {
  const $ = _c(4);
  const t = useTranslations("aria");
  let t0;
  if ($[0] !== t) {
    t0 = t("which_recommended_provider");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Image src={whichRecommendedProvider} alt={t0} width={118} height={94} className={styles.badge} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};